import { reducer } from "ts-action";
import { on } from "ts-action-immer";
import produce from "immer";
import {
  receiveTemplateBuilder,
  updateDetailTemplatesOrder,
  updatePresentationTemplate,
  updatePresentationTemplateItem,
  updatePresentationTemplateItems,
} from "../actionCreators";
import { AllPresentationTemplates } from "../../../requests/templateBuilder/types";
import guards from "../../../type-guards";

const initialState: AllPresentationTemplates = {} as AllPresentationTemplates;

const presentationTemplateReducer = reducer(
  initialState,
  on(receiveTemplateBuilder, (state, action) => {
    const { presentationTemplate } = action.payload.templateBuilder;
    return presentationTemplate;
  }),
  on(updatePresentationTemplate, (state, action) => {
    const { presentationTemplate } = action.payload;
    return presentationTemplate;
  }),
  on(updatePresentationTemplateItems, (state, action) => {
    const { hasPresentationModel } = guards.forPresentationTemplate;
    if (!hasPresentationModel(state)) return;

    state.items = action.payload.items;
  }),
  on(updatePresentationTemplateItem, (state, { payload: { item } }) => {
    const { hasPresentationModel } = guards.forPresentationTemplate;
    if (!hasPresentationModel(state)) return;

    state.items = produce(state.items, (draft) => {
      draft[item.id] = item;
    });
  }),
  on(updateDetailTemplatesOrder, (state, { payload: { templatesOrder } }) => {
    const { isMultiDetail } = guards.forPresentationTemplate;
    if (!isMultiDetail(state)) return;

    state.detailTemplatesOrder = templatesOrder;
  })
);

export default presentationTemplateReducer;
